// Initial state objects and arrays used by TirumalaDC.
// Centralizing these avoids any behavior change and keeps the main file clean.

export const initialLoanEntry = {
  loanAmount: "",
  loanSanctionDate: "",
  loanEndDate: "",
  loanType: "",
  lenderBranch: "",
  loanAccountNumber: "",
};

export const initialLoanDetails = [
  {
    ...initialLoanEntry,
  },
];

export const initialResponses = {
  medicalHistory: "",
  insuranceHistory: "",
  covidHistory: "",
  hazardousActivities: "",
};

export const initialImagePreviews = {
  aadharFrontPage: null,
  aadharBackPage: null,
  panImage: null,
  longQuestionnaire: null,
  membership: null,
};

export const initialFormData = {
  aadharFrontPage: null,
  aadharBackPage: null,
  panImage: null,
  longQuestionnaire: null,
  membership: null,
  customerId: "",
  dateOfBirth: "",
  age: "",
  firstname: "",
  lastname: "",
  gender: "",
  address: "",
  pincode: "",
  mobileNumber: "",
  emailId: "",
  aadhar: "",
  pan: "",
  nomineeName: "",
  nomineeRelation: "",
  nomineeAadharNo: "",
  nomineePanNo: "",
  nomineeDob: "",
  state: "",
  occupation: "",
  premiumIncGST: "",
};

// Kept exactly as in your component
export const requiredFields = [
  "customerId",
  "firstname",
  "lastname",
  "dateOfBirth",
  "nomineeDob",
  // "nomineeAge",
  "age",
  "gender",
  "address",
  "pincode",
  "mobileNumber",
  "emailId",
  "state",
];
